import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MarqueeProps {
    children: ReactNode
    direction?: 'left' | 'right'
    duration?: number
    className?: string
    groupClassName?: string
}

// An endless horizontal loop. The content is rendered twice and the track slides by
// exactly one copy, so give items trailing padding (not a gap) to keep the seam even.
// The parent must clip the overflow. Motion stops for visitors who prefer reduced motion.
export const Marquee: FC<MarqueeProps> = ({
    children,
    direction = 'left',
    duration = 25,
    className,
    groupClassName
}): ReactNode => {
    const style = { '--marquee-duration': `${duration}s` } as CSSProperties

    return (
        <div
            style={style}
            className={cn(
                'flex w-max will-change-transform motion-reduce:animate-none',
                direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right',
                className
            )}
        >
            <div className={cn('flex shrink-0', groupClassName)}>
                {children}
            </div>

            <div className={cn('flex shrink-0', groupClassName)} aria-hidden='true'>
                {children}
            </div>
        </div>
    )
}
